import {
  booleanAttribute,
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  InputSignal,
  InputSignalWithTransform,
  output,
  OutputEmitterRef,
  ViewEncapsulation
} from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { Router } from '@angular/router';
import { AppRoutes } from '@core';
import { OrIconComponent } from '../../or-icon/or-icon.component';

@Component({
  selector: 'lib-home-navbar',
  templateUrl: './home-navbar.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [IonicModule, OrIconComponent]
})
export class HomeNavbarComponent {
  readonly onAddGameOpened: OutputEmitterRef<void> = output<void>();
  readonly isNewNotifications: InputSignal<boolean> = input<boolean>(false);
  readonly showFiltersIcon: InputSignal<boolean> = input<boolean>(true);
  readonly extended: InputSignalWithTransform<boolean, unknown> = input(false, { transform: booleanAttribute });

  private readonly router: Router = inject(Router);

  openNotifications(): void {
    this.router.navigate([AppRoutes.NOTIFICATIONS]);
  }

  addGame(): void {
    this.onAddGameOpened.emit();
  }
}
